// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"95":"89abdb27","316":"41595579","421":"bd5f03be","453":"6c7aee2b","455":"7a9c4187","466":"643caf49","680":"a4121c9c","802":"eaacaab1","866":"17bc5fa0","868":"6b7718cb","869":"a9c7c6ff","923":"bb6fe23d","977":"06843cd1"}[chunkId] + ".chunk.js";
};